const booking = {
  bookingInformation: "Boekingsinformatie", // translated
  ourCancellationPolicy: "Onze annuleringsvoorwaarden", // translated
  thisAupersedesAnyCancellationPolicyInRemarksAbove: "Dit vervangt alle annuleringsvoorwaarden in bovenstaande opmerkingen", // translated
  thisBookingIsNonNefundable: "Deze boeking kan niet worden gerestitueerd", // translated
  paymentTerms: "Betaalvoorwaarden", // translated
  paymentWillBeTakenFromYourDefault: "De betaling wordt van uw standaard afgeschreven", // translated
  paymentMethod: "betalingsmiddel", // translated
  afterTheFreeCancellationPeriodIfApplicable: "na de gratis opzegtermijn indien van toepassing", // translated
  prebook: "Vooraf boeken", // translated
  guests: "Gasten", // translated
  payment: "Betaling", // translated
  byClicking: "Door te klikken", // translated
  youAreAgreeingToOur: "je gaat akkoord met onze", // translated
  termsAndConditions: "Voorwaarden", // translated
  lastBookableDate: "Laatste boekbare datum", // translated
  request: "Verzoek", // translated
  customerRemarksTextfield: "Opmerkingen van klanten", // translated
};


export default booking;
